import React, { useCallback } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import LoadingSpinner from '../../components/LoadingSpinner';
import { RequestState } from '../hooks/useRequestState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { useApiRequest } from 'shared/auth/hooks/useApiRequest';
import { resendConfirmationCode } from 'shared/auth/ui/verifyUserApi';

const StyledButton = styled(Button)`
  &:button.MuiButtonBase-root.Mui-disabled {
    .MuiButton-label {
      color: rgba(0, 0, 0, 0.26);
    }
    border-color: rgba(0, 0, 0, 0.12);
  }
  .button-container {
    width: 112px;
    display: flex;
    justify-content: center;
    align-items: center;
    .spinner,
    .success {
      margin-left: 10px;
    }
    .success {
      color: var(--success);
    }
    .text {
      text-align: left;
      display: inline-block;
      width: 100px;
    }
  }
`;

const getResendButtonText = (request: RequestState<unknown>): JSX.Element => {
  switch (request.type) {
    case 'REQUEST_START':
      return (
        <div className="button-container">
          <div className="text">Sending...</div>
          <LoadingSpinner className="spinner" size={16} />
        </div>
      );
    case 'REQUEST_ERROR':
      return <div className="button-container">Try again!</div>;

    case 'REQUEST_SUCCESS':
      return (
        <div className="button-container">
          <div className="text">Sent!</div>
          <FontAwesomeIcon icon={faCheck} className="success" />
        </div>
      );

    default:
      return <div className="button-container">Re-send Email</div>;
  }
};

interface ResendVerificationCodeProps {
  email: string;
  className?: string;
}

const ResendVerificationCode: React.FC<ResendVerificationCodeProps> = ({
  email,
  className,
}) => {
  const [resend, makeResendRequest] = useApiRequest<unknown>();
  const handleResend = useCallback(() => {
    makeResendRequest(resendConfirmationCode(email));
  }, [makeResendRequest, email]);
  return (
    <StyledButton
      color="primary"
      variant="contained"
      onClick={handleResend}
      disabled={
        resend.type === 'REQUEST_START' || resend.type === 'REQUEST_SUCCESS'
      }
      className={className}
    >
      {getResendButtonText(resend)}
    </StyledButton>
  );
};

export default ResendVerificationCode;
